export function goToNextReconAccount() {
    window['recon'] &&
        window['recon'].goToNextReconAccount &&
        window['recon'].goToNextReconAccount();
}

export function goToPrevReconAccount() {
    window['recon'] &&
        window['recon'].goToPrevReconAccount &&
        window['recon'].goToPrevReconAccount();
}

export function getTotalAccounts() {
    return (
        window['recon'] && window['recon'].getTotalAccounts && window['recon'].getTotalAccounts()
    );
}

export function getActiveAccount() {
    return (
        window['recon'] && window['recon'].getActiveAccount && window['recon'].getActiveAccount()
    );
}

export function getAccountName() {
    return window['recon'] && window['recon'].getAccountName && window['recon'].getAccountName();
}

export function getAccountNumber() {
    return (
        window['recon'] && window['recon'].getAccountNumber && window['recon'].getAccountNumber()
    );
}

export function zoomAccount() {
    return window['recon'] && window['recon'].zoomAccount && window['recon'].zoomAccount();
}

export function getFormName() {
    return (
        window['formTable'] && window['formTable'].getFormName && window['formTable'].getFormName()
    );
}

export function getParentFormName() {
    return (
        window['formTable'] &&
        window['formTable'].getParentFormName &&
        window['formTable'].getParentFormName()
    );
}

export function getTextFormName() {
    return (
        window['formTable'] &&
        window['formTable'].getTextFormName &&
        window['formTable'].getTextFormName()
    );
}

export function isReconTabledFilled() {
    return (
        window['formTable'] &&
        window['formTable'].isReconTabledFilled &&
        window['formTable'].isReconTabledFilled()
    );
}
